/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Icons
 */
import { TickIcon } from '../../../images/icons/Tick/Tick'

/**
 *     Import
 *     - CSS
 */
import './styles/Checkbox.css'

class Checkbox extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
            selected: (this.props.selected) ? this.props.selected : false,
            selectedAll: false,
            name: this.props.name || 'noname',
        }
    }

    /**
     * When component State updates
     */
    componentDidUpdate(prevProps: any, prevState: any) {

        if (prevState.selected !== this.state.selected && prevState.selected !== undefined) {
            /**
             * If the intern state changes call onChange props function
             */
            this.props.onChange(this.state.selected, this.state.name)
        }

        if (prevProps.selected !== this.props.selected && this.props.controlByOther) {
            this.setState({ selected: this.props.selected })
        }

    }

    /**
     * When component Props updates
     */
    componentWillUpdate(nextProps: any, nextState: any) {
        if ((nextProps.selectAll !== undefined) &&
            (nextProps.selectAll !== this.state.selectedAll)) {
            this.setState({ selected: nextProps.selectAll, selectedAll: nextProps.selectAll })
        }
        if (nextProps.selected && !this.state.selected) {
            this.setState({ selected: true })
        }
        if (nextProps.changeState && !this.state.selected) {
            this.setState({ selected: true })
        }
    }

    /**
     * Toggle select state when click happens
     */
    handleClick = () => this.setState({ selected: !this.state.selected })

    render() {

        const { last, first, short, className, children } = this.props
        let { selected } = this.state

        let classList = `checkbox
            ${(className) ? className : ''}
            ${(last) ? 'last' : ''}
            ${(first) ? 'first' : ''}
            ${(short) ? 'short' : ''}`

        return (
            <div
                className={classList}
            >
                <div onClick={this.handleClick} className={`checkbox__tick ${(selected) ? 'active' : ''}`}>
                    <TickIcon />
                </div>
                <div className="checkbox__content" onClick={this.handleClick} >{children}</div>
            </div>
        )
    }
}

export default Checkbox



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Checkbox/Checkbox.tsx